export default "__VITE_ASSET__Cl5EgopY__"